import request from '@/utils/request'
import {dealDownloadFileResponse} from "@/api/file";
import {formatDataFromSever,formatMainDataFromSever} from "@/views/WorkSheet/xml-manager";
import {getToken} from '@/utils/auth'
import {encrypt} from "@/utils/encrypt";

export function GetCommonDDLList({userId,type=''}) {
    return request({url: `/appi/ZC/GetCommonDDLList?userId=${userId}&type=${type}`}).then(res=>{
        res.data = res.data.map(item=>{
            const {dictId, dictValue} = item;
            return {value:dictId, label: dictValue}
        })
        return Promise.resolve(res);
    })
}

//***************************************订单类******************************************** */
//获取订单列表
export function ZC_GetOrderList({userId,key,statusIds,sDate,eDate,isValidDate,productIds,clientIds=''}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/zc/ZC_GetOrderList?userId=${userId}&sDate=${sDate}&eDate=${eDate}&key=${key}&statusIds=${statusIds}&isValidDate=${isValidDate}&productIds=${productIds}&clientIds=${clientIds}`
    })
    
}

export function ImportOrderExcel({userId, formData}) {
    return request({
        url: `/appi/zc/ImportOrderExcel?userId=${userId}`,
        data: formData
    })
    // .then(res => {
    //     return Promise.resolve(res);
    // });
}

//订单入库
export function ZC_Import(data) {
    return request({
        url: `/appi/zc/ZC_Import`,
        data
    });
}


//*****************************************任务类********************************************* */
//获取任务列表
export function ZC_GetPlanList({userId,companyId=-1,key,statusIds,sDate,eDate}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/zc/ZC_GetPlanList?userId=${userId}&companyId=${companyId}&sDate=${sDate}&eDate=${eDate}&key=${key}&statusIds=${statusIds}`
    })    
}

//获取任务列表-按各统计类型
export function ZC_GetPlanList_ByCate({userId,monthSeg='',servicetype='',clientGrade=''}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/zc/ZC_GetPlanList_ByCate?userId=${userId}&monthSeg=${monthSeg}&servicetype=${servicetype}&clientGrade=${clientGrade}`
    })    
}

//保存任务
export function ZC_SavePlan({id,isAgent,agentId,companyId,orderId,seg,serviceTypeId,planSDate,planEDate,topic,content,remark,samples}) {
    // console.log('data',data)
    return request({
        url: `/appi/zc/ZC_SavePlan`,
        data:{
            userId:getToken(),id,isAgent,agentId,companyId,orderId,seg,serviceTypeId,planSDate,planEDate,topic,content,remark,samples
        }
    });
}

//删除执行计划
export function ZC_DelPlan({userId,id}) {
    return request({
        url: `/appi/zc/ZC_DelPlan?userId=${userId}&id=${id}`
    })    
}

//************************************任务执行类***********************************/
//获取任务列表
export function ZC_GetResultList({userId,key,planId,companyId,isAgent,sDate,eDate}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/zc/ZC_GetResultList?userId=${userId}&sDate=${sDate}&eDate=${eDate}&key=${key}&planId=${planId}&companyId=${companyId}&isAgent=${isAgent}`
    })    
}

//保存任务
export function ZC_SaveResult({id,planId,dealDate,dealContent,dealResult,provideTypeIds,samples,innerRemark=''}) {
    // console.log('data',data)
    return request({
        url: `/appi/zc/ZC_SaveResult`,
        data:{
            userId:getToken(),id,planId,dealDate,dealContent,dealResult,provideTypeIds,samples,innerRemark
        }
    });
}

//删除执行计划
export function ZC_DelResult({userId,id}) {
    return request({
        url: `/appi/zc/ZC_DelResult?userId=${userId}&id=${id}`
    })    
}

//结案
export function ZC_FinishPlan({planId,finishTime,finishDescript,renewResultId,unRenewReason}) {
    return request({
        url: `/appi/zc/ZC_FinishPlan?userId=${getToken()}&planId=${planId}&finishTime=${finishTime}&finishDescript=${finishDescript}&renewResultId=${renewResultId}&unRenewReason=${unRenewReason}`
    })    
}


//************************************培训类***********************************/
//获取任务列表
export function ZC_GetTrainList({userId,key,typeIds,sDate,eDate}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/zc/ZC_GetTrainList?userId=${userId}&sDate=${sDate}&eDate=${eDate}&key=${key}&typeIds=${typeIds}`
    })    
}

//保存任务
export function ZC_SaveTrain({id,isAgent,agentId,companyId,topic,trainDate,typeIds,attendCnt,answerCnt,planId,remark,samples}) {
    // console.log('data',data)
    return request({
        url: `/appi/zc/ZC_SaveTrain`,
        data:{
            userId:getToken(),id,isAgent,agentId,companyId,topic,trainDate,typeIds,attendCnt,answerCnt,planId,remark,samples
        }
    });
}

//删除执行计划
export function ZC_DelTrain({userId,id}) {
    return request({
        url: `/appi/zc/ZC_DelTrain?userId=${userId}&id=${id}`
    })    
}

//************************************客户信息***********************************/
//保存客户信息
export function ZC_SaveClient({userId,id,clientName}) {
    return request({
        url: `/appi/zc/ZC_SaveClient?userId=${userId}&id=${id}&clientName=${clientName}`
    })    
}
//删除客户信息
export function ZC_DelClient({userId,id}) {
    return request({
        url: `/appi/zc/ZC_DelClient?userId=${userId}&id=${id}`
    })    
}
//获取客户列表
export function ZC_GetClientList({userId,key,sDate='',eDate=''}) {
    return request({
        url: `/appi/zc/ZC_GetClientList?userId=${userId}&key=${key}&sDate=${sDate}&eDate=${eDate}`
    })    
}

export function ZC_SaveClientDefine({userId,id,define}) {
    return request({
        url: `/appi/zc/ZC_SaveClientDefine?userId=${userId}&id=${id}&define=${define}`
    })    
}

//************************************代理商信息***********************************/
//获取代理商列表
export function ZC_GetAgentList({userId,key,sDate='',eDate=''}) {
    return request({
        url: `/appi/zc/ZC_GetAgentList?userId=${userId}&key=${key}&sDate=${sDate}&eDate=${eDate}`
    })    
}

//保存代理商自定义信息
export function ZC_SaveAgentDefine({userId,id,define}) {
    return request({
        url: `/appi/zc/ZC_SaveAgentDefine?userId=${userId}&id=${id}&define=${define}`
    })    
}


//************************************首页***********************************/
export function ZC_Index({userId}) {
    return request({
        url: `/appi/zc/ZC_Index?userId=${userId}`
    })    
}

//************************************预警***********************************/
export function ZC_GetAlertList({userId}) {
    
    return request({
        url: `/appi/zc/ZC_GetAlertList?userId=${userId}&key=&typeIds=&sDate=&eDate=`
    })    
}



//************************************报告***********************************/
/**
 * 导出筑巢报告
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
 export function ExportMSReport({sDate='',eDate=''}) {
    return request({
        url: `/appi/Operate/ExportMSReport?uId=${encrypt(getToken())}&sDate=${sDate}&eDate=${eDate}`,
        method: 'get',
        responseType: 'blob'
    }).then(res => {
        console.log(res);
        return dealDownloadFileResponse({res});
    })
}